import {
  Injectable,
  signal,
  computed,
  inject,
  DestroyRef,
  Signal,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import type { Observable } from 'rxjs';

export const MOBILE_BREAKPOINT = 768;

@Injectable({ providedIn: 'root' })
export class ViewportService {
  public readonly width: Signal<number>;
  public readonly isMobileView: Signal<boolean>;
  public readonly isMobileView$: Observable<boolean>;

  private readonly destroyRef = inject(DestroyRef);
  private readonly widthSignal = signal<number>(window.innerWidth);

  public constructor() {
    this.width = this.widthSignal.asReadonly();
    this.isMobileView = computed(() => this.widthSignal() < MOBILE_BREAKPOINT);
    this.isMobileView$ = toObservable(this.isMobileView);

    this.initResizeListener();
  }

  private initResizeListener(): void {
    const handleResize = (): void => {
      this.widthSignal.set(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('resize', handleResize);
    });
  }
}
